<script setup lang="ts">
import { Toaster } from '@/components/ui/toast'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { useAuthStore } from '@/store/auth'
import { onMounted } from 'vue'

const authStore = useAuthStore()

onMounted(() => {
  authStore.initAuth()
})
</script>

<template>
  <router-view />
  <Toaster />
  <Sonner position="top-right" richColors />
</template>
